import { render, staticRenderFns } from "./emarticonRegistration.vue?vue&type=template&id=022ca170&scoped=true"
import script from "./emarticonRegistration.vue?vue&type=script&lang=js"
export * from "./emarticonRegistration.vue?vue&type=script&lang=js"
import style0 from "./emarticonRegistration.vue?vue&type=style&index=0&id=022ca170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022ca170",
  null
  
)

export default component.exports